export default __webpack_public_path__ + "static/media/2_create_blank.1e31d96e.svg";